import React from 'react';
import PropTypes from 'prop-types';
import { FieldArray } from 'redux-form';
import BudgetCosts from '../BudgetCosts';

const validateAmount = (value, minimumAmount, maximumAmount) => {
  const sum = value ? value.filter(c => c.value).map(c => c.value).reduce((a, b) => a + b, 0) : 0;
  if (sum < minimumAmount || sum > maximumAmount) return `Kwota musi być większa od ${minimumAmount} i mniejsza od ${maximumAmount}`;
  return null;
};

const ApplicationFormCostsField = ({ field, index, applicationForm, change, totalCost, readonly }) =>(
  <div className="box">
    <div className="col-sm-12">
      <h3>{index + 1}. {field.title}</h3>
      <p>{field.description}</p>
      <FieldArray
        name="costs"
        component={BudgetCosts}
        onValueChange={() => {
          if (applicationForm.districtsAttributes && applicationForm.districtsAttributes.length) {
            const district = applicationForm.districtsAttributes.find(d => d.costDependent && totalCost >= d.minimumCost && totalCost <= d.maximumCost);
            if (district) {
              change('district', district.name);
            } else {
              change('district', null);
            }
          }

          if (applicationForm.categories && applicationForm.categories.length) {
            const category = applicationForm.categories.find(c => c.costDependent && totalCost >= c.minimumCost && totalCost <= c.maximumCost);
            if (category) {
              change('category', category.name);
              if (category.subcategories && category.subcategories.length) {
                const subcategory = category.subcategories.find(c => c.costDependent && totalCost >= c.minimumCost && totalCost <= c.maximumCost);
                if (subcategory) {
                  change('subcategory', subcategory.name);
                } else {
                  change('subcategory', null);
                }
              } else {
                change('subcategory', null);
              }

            } else {
              change('category', null);
              change('subcategory', null);
            }
          }
        }}
        validate={value => applicationForm.amountValidation ? validateAmount(value, applicationForm.minimumAmount, applicationForm.maximumAmount) : null}
        readonly={readonly}
      />
    </div>
  </div>
);

ApplicationFormCostsField.propTypes = {
  change: PropTypes.func.isRequired,
  field: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  applicationForm: PropTypes.object.isRequired,
  totalCost: PropTypes.number,
  readonly: PropTypes.bool,
};

export default ApplicationFormCostsField;


// WEBPACK FOOTER //
// ./src/components/budget/applicationForm/ApplicationFormCostsField.js